/* Organized Pill — premium layer v1 */
(function () {
  'use strict';

  /* Every OP section includes this file; only run once per page. */
  if (window.__opPremiumLoaded) return;
  window.__opPremiumLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.op-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          el.classList.add('is-in');
          io.unobserve(el);
          /* Clear the stagger delay afterwards so hover effects stay instant. */
          setTimeout(function () { el.style.transitionDelay = ''; }, 1400);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }

  function initAnnounce(root) {
    (root || document).querySelectorAll('[data-op-announce]').forEach(function (bar) {
      if (bar.__opReady) return;
      bar.__opReady = true;
      var items = bar.querySelectorAll('.op-announce__item');
      if (items.length < 2 || reduce || bar.getAttribute('data-autoplay') !== 'true') return;
      var index = 0;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5000;
      var timer;
      function tick() {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }
      function stop() { clearInterval(timer); }
      function start() { stop(); timer = setInterval(tick, speed); }
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });
      start();
    });
  }

  function initWall(root) {
    (root || document).querySelectorAll('[data-op-expand]').forEach(function (btn) {
      if (btn.__opReady) return;
      btn.__opReady = true;
      var wall = document.getElementById(btn.getAttribute('aria-controls'));
      if (!wall) return;
      btn.addEventListener('click', function () {
        var wasCollapsed = wall.hasAttribute('data-collapsed');
        if (wasCollapsed) { wall.removeAttribute('data-collapsed'); } else { wall.setAttribute('data-collapsed', ''); }
        btn.setAttribute('aria-expanded', wasCollapsed ? 'true' : 'false');
        var label = btn.querySelector('[data-label]');
        if (label) { label.textContent = wasCollapsed ? btn.getAttribute('data-less') : btn.getAttribute('data-more'); }
        if (!wasCollapsed) { wall.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      });
    });
  }

  function initAll(root) {
    initReveal(root);
    initAnnounce(root);
    initWall(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();